import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Navbar, Container, Button } from 'react-bootstrap';
import { FaMoneyBillWave, FaCoins, FaBookOpen, FaShoppingCart, FaCheckCircle, FaTrash } from 'react-icons/fa';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const SummaryHeader = ({ totalPaid, totalUnpaid, totalBooks, totalOrders, deliveredCount, userCount, deletedItemsCount, deletedItemsPrice }) => {
    const navigate = useNavigate();

    const safeDeletedItemsPrice = Number(deletedItemsPrice || 0);
    const safeDeletedItemsCount = Number(deletedItemsCount || 0);
    const safeTotalPaid = Number(totalPaid || 0);
    const safeTotalUnpaid = Number(totalUnpaid || 0);
    const effectiveUnpaid = safeTotalUnpaid - safeDeletedItemsPrice;

    return (
        <>
            <Button
                variant="outline-primary"
                className="mb-3"
                style={{ borderRadius: "10px", padding: "6px 16px" }}
                onClick={() => navigate(-1)}
                >
                ← Terug
            </Button>
            <Navbar bg="primary" variant="dark" className="mb-3 py-2">
                <Container>
                    <div className="summary-header-wrapper w-100 d-flex flex-wrap justify-content-center align-items-center text-white">

                    <div className="summary-item d-flex align-items-center mx-3 my-2">
                        <FaMoneyBillWave className="me-2" />
                        <span>Betaald: € {safeTotalPaid.toFixed(2)}</span>
                    </div>

                    <div className="separator d-none d-md-block">|</div>

                    {/* <div className="summary-item d-flex align-items-center mx-3 my-2">
                        <FaCoins className="me-2" />
                        <span>Onbetaald: € {effectiveUnpaid.toFixed(2)}</span>
                    </div> */}
                    {/* Unpaid with tooltip */}
                    <OverlayTrigger
                        placement="bottom"
                        overlay={
                            <Tooltip id="unpaid-tooltip">
                                Onbetaald bedrag is exclusief deleted items
                            </Tooltip>
                        }
                    >
                        <div className="summary-item d-flex align-items-center mx-3 my-2" style={{ cursor: "help" }}>
                            <FaCoins className="me-2" />
                            <span>Onbetaald: € {effectiveUnpaid.toFixed(2)}</span>
                        </div>
                    </OverlayTrigger>

                    <div className="separator d-none d-md-block">|</div>

                    <div className="summary-item d-flex align-items-center mx-3 my-2">
                        <FaTrash className="me-2" />
                        <span>Verwijderd ({safeDeletedItemsCount}) {safeDeletedItemsCount > 0 && `(${safeDeletedItemsCount})`}: € {safeDeletedItemsPrice.toFixed(2)}</span>
                    </div>

                    <div className="separator d-none d-md-block">|</div>

                    <div className="summary-item d-flex align-items-center mx-3 my-2">
                        <FaBookOpen className="me-2" />
                        <span>Boeken: {totalBooks}</span>
                    </div>

                    <div className="separator d-none d-md-block">|</div>

                    <div className="summary-item d-flex align-items-center mx-3 my-2">
                        <FaShoppingCart className="me-2" />
                        <span>Bestellingen: {totalOrders}</span>
                    </div>

                    <div className="separator d-none d-md-block">|</div>

                    <div className="summary-item d-flex align-items-center mx-3 my-2">
                        <FaCheckCircle className="me-2" />
                        <span>Geleverd: {deliveredCount} / {totalOrders}</span>
                    </div>
                    </div>
                </Container>

                <style>
                    {`
                    .summary-item span {
                        white-space: nowrap;
                    }
                    .separator {
                        margin: 0 10px;
                        opacity: 0.7;
                    }

                    @media (max-width: 768px) {
                        .separator {
                        display: none !important;
                        }
                    }
                    `}
                </style>
            </Navbar>
        </>
    );
};

export default SummaryHeader;